if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
    
    $('a[href*="choicehotels.com"]').each(function() {
        var $this = $(this);       
        var _href = $this.attr("href");
        if (_href.indexOf('?') >= 0) {
            $this.attr("href", _href + "&mc=frtmxxpx");
        }else{
            $this.attr("href", _href + "?mc=frtmxxpx");
        }
    });

    $('.sym-slides').slick({
        accessibility: false,
    });
    setTimeout(function(){ 
        $('a[href*="/privacy-policy"]').each(function(){ 
            $(this).attr("href", "/choice-hotels-privacy-policy"); 
        });
    }, 2000); 

})();